import { render, staticRenderFns } from "./SocialShareWidget.vue?vue&type=template&id=682a88ed&"
import script from "./SocialShareWidget.vue?vue&type=script&lang=js&"
export * from "./SocialShareWidget.vue?vue&type=script&lang=js&"
import style0 from "./SocialShareWidget.vue?vue&type=style&index=0&id=682a88ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports